import { render, staticRenderFns } from "./VRestrictCard.vue?vue&type=template&id=89775ac4&scoped=true"
import script from "./VRestrictCard.vue?vue&type=script&lang=js"
export * from "./VRestrictCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89775ac4",
  null
  
)

export default component.exports